import Immutable from 'immutable';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectBrowseHomeConfig } from 'app/selectors/browse/browseHomeSelector';
import AdminBrowseHomePagePreviewBanner from './AdminBrowseHomePagePreviewBanner';

const AdminBrowseHomePagePreviewBannerContainer = () => {
  const location = useLocation();
  const { pathname } = location;
  const isPreview = pathname.indexOf('/preview/') > -1;

  const browseHomePageConfig = useSelector(selectBrowseHomeConfig) ?? Immutable.Map();
  if (!isPreview || (browseHomePageConfig?.isEmpty() ?? true)) {
    return null;
  }

  const pageTitle = browseHomePageConfig?.get('pageTitle');
  const message = `You are previewing the ‘${pageTitle}’ home page.`;

  return <AdminBrowseHomePagePreviewBanner message={message} />;
};

export default AdminBrowseHomePagePreviewBannerContainer;
